import { Fragment, ReactElement, useEffect } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { systemEventActions } from '../../redux/slices/system-event.slice';
import { RootState } from '../../redux/store';
import { styles } from './system-event-badge-card.styles';
import PortalWrapper from '../portal-wrapper';

const SystemEventBadgeCard = (): ReactElement => {
  const dispatch = useDispatch();

  const systemEventsRaw = useSelector((state: RootState) => state.systemEvents?.all);
  const isLoaded = useSelector((state: RootState) => state.systemEvents?.isLoaded);

  const systemEvents = Array.isArray(systemEventsRaw) ? systemEventsRaw : [];

  useEffect(() => {
    dispatch(systemEventActions.getAll({ page: 1 }));
  }, [dispatch]);

  const handleSystemEventCardClose = () => {
    dispatch(systemEventActions.setSystemEventBadgeCardOpen(false));
  };

  const handleDeleteAll = () => {
    dispatch(systemEventActions.deleteAll());
  };

  return (
    <Fragment>
      <PortalWrapper onClose={handleSystemEventCardClose}>
        <Box sx={styles.mainBox}>
          <Box sx={styles.headerRow}>
            <Typography sx={styles.title}>Notifications</Typography>
            {systemEvents.length > 0 && (
              <Button sx={styles.clearButton} onClick={handleDeleteAll}>
                Clear all
              </Button>
            )}
          </Box>

          {!isLoaded ? (
            <Box sx={styles.placeholderText}>Loading...</Box>
          ) : systemEvents.length === 0 ? (
            <Box sx={styles.placeholderText}>No notifications</Box>
          ) : (
            <Box sx={styles.list}>
              {systemEvents.map((item: any) => (
                <Box key={item._id} sx={styles.item}>
                  <Typography sx={styles.itemTitle}>
                    {item.title || 'Notification'}
                  </Typography>

                  {!!item.message && (
                    <Typography sx={styles.itemMessage}>{item.message}</Typography>
                  )}

                  <Typography sx={styles.itemDate}>
                    {item.createdAt
                      ? new Date(item.createdAt).toLocaleString()
                      : ''}
                  </Typography>
                </Box>
              ))}
            </Box>
          )}
        </Box>
      </PortalWrapper>
    </Fragment>
  );
};

export default SystemEventBadgeCard;